import { render, staticRenderFns } from "./CouponIdCell.vue?vue&type=template&id=66b1dc5b&scoped=true&"
import script from "./CouponIdCell.vue?vue&type=script&lang=js&"
export * from "./CouponIdCell.vue?vue&type=script&lang=js&"
import style0 from "./CouponIdCell.vue?vue&type=style&index=0&id=66b1dc5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1dc5b",
  null
  
)

export default component.exports